import { render } from "./AttributesSelectInput.vue?vue&type=template&id=a04849e0&ts=true"
import script from "./AttributesSelectInput.vue?vue&type=script&lang=ts"
export * from "./AttributesSelectInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__